var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m18.72 13.633-4.058 4.057a.956.956 0 0 1-1.353 0l-2.029-2.028a.956.956 0 1 1 1.353-1.352l1.352 1.352 3.382-3.382a.956.956 0 1 1 1.353 1.353M15 7a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
})));
export default SvgCheckmarkCircle;